import classNames from 'classnames';
import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';

import styles from './Skeleton.module.css';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  isLoaded?: boolean;
  children?: ReactNode;
}

export const Skeleton = ({
  isLoaded = false,
  children,
  className,
  ...rest
}: SkeletonProps) => {
  if (isLoaded) {
    return <>{children}</>;
  }

  return (
    <div
      className={classNames(styles.skeleton, className)}
      aria-hidden="true"
      {...rest}
    />
  );
};

export interface SkeletonTextProps extends HTMLAttributes<HTMLDivElement> {
  noOfLines?: number;
  spacing?: number | string;
  isLoaded?: boolean;
  children?: ReactNode;
}

export const SkeletonText = ({
  noOfLines = 3,
  spacing = 3,
  isLoaded = false,
  children,
  className,
  style,
  ...rest
}: SkeletonTextProps) => {
  if (isLoaded) {
    return <>{children}</>;
  }

  const mergedStyle: CSSProperties = {
    gap: typeof spacing === 'number' ? `${spacing * 0.25}rem` : spacing,
    ...style,
  };

  return (
    <div
      className={classNames(styles.text, className)}
      style={mergedStyle}
      aria-hidden="true"
      {...rest}
    >
      {Array.from({ length: noOfLines }, (_, index) => (
        <div
          key={`line-${index}`}
          className={classNames(
            styles.skeleton,
            styles.line,
            index === noOfLines - 1 && noOfLines > 1
              ? styles.lastLine
              : undefined
          )}
        />
      ))}
    </div>
  );
};
